import request from "@/utils/request"

// 获取基地人员
export const getBasePerson = async (baseid, employeeType, name, page) => {
  let res = await request.get('/base/users', { params: { baseid: baseid, employeeType: employeeType, name: name, current: page } })
  return res
}


